/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedSearchRedirectNotice_itemSearch$ref = any;
export type SbSharedSearchRedirectNotice_itemSearch = {
    readonly pageType: string | null;
    readonly spellCheck: {
        readonly newQuery: string | null;
        readonly oldQuery: string | null;
        readonly redirect: {
            readonly redirectFrom: string | null;
        } | null;
    } | null;
    readonly " $refType": SbSharedSearchRedirectNotice_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedSearchRedirectNotice_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "spellCheck",
            "storageKey": null,
            "args": null,
            "concreteType": "SpellcheckSuggestions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "newQuery",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "oldQuery",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "redirect",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SpellcheckSuggestionsRedirected",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "redirectFrom",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'c4639dfa03e58bcbc5c6f2942a5651d5';
export default node;
